import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';


@Component({
    selector: 'app-input-tag',
    templateUrl: './input-tag.component.html',
    styleUrls: ['./input-tag.component.css'],
})


export class InputTagComponent implements OnInit {

    // Customize Input field for varios Input action to avoid repetation
    // @Input() props: { receivedPlaceholderMsg: string, nameTxt: string };
    @Input() receivedPlaceholderMsg: string;
    @Input() nameTxt: string;
    @Input() typeInfo: any;

    @Output() emitInputValue = new EventEmitter<string | number>();

    // private numberOfClicks = 0;

    constructor() { }

    updateValue(value: number | string) {
        this.emitInputValue.emit(value);
    }



    ngOnInit() {
    }

}
